import React from 'react';
import { Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-black/5 py-12" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-71">
          <div className="text-center md:text-left" data-id="element-72">
            <span className="text-xl font-semibold tracking-tight text-black" data-id="element-73">
              Archaitechs
            </span>
            <p className="text-sm font-light text-neutral-400 mt-2" data-id="element-74">
              © 2026 Archaitechs. Alle Rechte vorbehalten.
            </p>
          </div>

          <div className="flex items-center gap-8" data-id="element-75">
            <a href="#impressum" className="text-sm font-light text-neutral-400 hover:text-black transition-colors" data-id="element-76">
              Impressum
            </a>
            <a href="#" className="text-sm font-light text-neutral-400 hover:text-black transition-colors" data-id="element-77">
              Datenschutz
            </a>
            <a href="#" className="text-neutral-400 hover:text-black transition-colors" data-id="element-78">
              <Linkedin className="w-5 h-5" data-id="element-79" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}